import {DownloadSearchPanel} from "./searchPanel"
import {ENavLanguages, JDownloadProductSource, L10nLabels} from "../../commons/api";
import {labels as commonLabels} from "../../commons/commons";
import {lang} from "../../commons/language-selector";
import {SvcESSearch} from "wfr/search/essearch";
import {JHitSource} from "wfr/search/searchapi";
import {JSX} from "wfr/commons/jsx"
import {ETileTitle, ProductTile} from "../product-tile";
import { Dict } from "wfr/commons/common";
import { QuickAccess } from "../quick-access";
import {qs, updateHistory } from "wfr/commons/core";

//API
export {DownloadSearchPanel, init, QuickAccess}

//Pour usage interne...
export {urltree, es}

const labels:L10nLabels = {
	[ENavLanguages.fr]:{
		"app":"Applications",
		"appTagline":"MyScenari, Opale, Dokiel...",
		"ext":"Extensions",
		"extTagline":"Habillages, générateurs...",
		"server":"Serveurs",
		"serverTagline":"SCENARIserver, SCENARIsuite-starter",
		"dev":"Outils de développement"
	},
	[ENavLanguages.en]:{
		"app":"Applications",
		"appTagline":"MyScenari, Opale, Dokiel...",
		"ext":"Extensions",
		"extTagline":"Skins, generators...",
		"server":"Servers",
		"serverTagline":"SCENARIserver, SCENARIsuite-starter",
		"dev":"Development tools"
	}
}

let urltree:string
let es:string

/**
 * Point d'entrée d'init de la page.
 */
async function init(downloadUT:string, downloadSearch:string) {
	urltree = downloadUT
	es = downloadSearch;

	const quickaccess = (document.querySelector("quick-access") as QuickAccess);
	quickaccess.init(urltree, es).then()
	quickaccess.rebuild();
	//Insertion des labels localisés absents de la publis
	document.querySelectorAll("span.l10n").forEach(span=> span.textContent = s(span.getAttribute("data-l10n-key")));
	//Init des panels Searchs
	document.querySelectorAll("download-search-panel").forEach(panel => {
		if(panel.getAttribute("request") != "extSearch") (panel as DownloadSearchPanel).static_init(downloadUT, downloadSearch)
	})
	const loaded:Dict<boolean> = {}
	//Init spécifique de extSearch après appSearch
	document.addEventListener("search-initiated", (event:CustomEvent)=> {
		loaded[event.detail.query] = true;
		if ((event.detail.query == "appSearch" || event.detail.query == "devSearch") && loaded["appSearch"] && loaded["devSearch"]) {
			const extSearch:DownloadSearchPanel = document.querySelector("download-search-panel[request='extSearch']") as DownloadSearchPanel;
			extSearch.static_init(downloadUT, downloadSearch)
		}
	});
	//Init des buttons de tab
	(document.querySelectorAll("button.tabbtn") as NodeListOf<HTMLButtonElement>).forEach(button=>{
		button.addEventListener("click", changeTab);
		if(qs().panel == button.getAttribute("data-tab")) button.classList.add("selected")
		else if (qs().panel) button.classList.remove("selected")
	});
	(document.querySelectorAll("div.tab") as NodeListOf<HTMLDivElement>).forEach(tab=>{
		if(qs().panel == tab.id) tab.hidden = false
		else if (qs().panel) tab.hidden = true
	});


	//Init d'un esSearch pour populer les liens esSearch et
	const esSearch:SvcESSearch<JHitSource<JDownloadProductSource>> = new SvcESSearch(downloadSearch)

	//Init des liens posés en durs
	const paths:string[] = []
	const lnks = document.querySelectorAll("a.authoredLink");
	lnks.forEach(a=> paths.push(`${a.getAttribute("href")}*`));
	const buckets:JPKBucket[] = (await esSearch.search("paths", {"path":paths, "size":paths.length})).agg.productKey.buckets
	buckets.forEach(bucket=>{
		lnks.forEach(lnk=>{
			if(lnk.getAttribute("href").indexOf(bucket.key) != -1){
				const li = lnk.parentElement;
				li.innerHTML = ""
				li.append(new ProductTile(bucket.last.hits.hits[0]._source, urltree, {title:ETileTitle.label, addClassName:"aside"}))
			}
		})
	});

	//Init list des derniers ajouts
	for (const list of document.querySelectorAll("div.list_co[data-size]")) {
		const res = await esSearch.search("lasts", {"size":list.getAttribute("data-size")});
		list.innerHTML = ""
		list.append(<ul>{res.results.map(hit=> <li>{new ProductTile(hit._source, urltree, {title:ETileTitle.long, addClassName:"aside"})}</li>)}</ul>)
	}
}

function s(key:string, ...args:any):string{
	if(key in commonLabels){
		if(typeof commonLabels[lang][key] == "function") return (commonLabels[lang][key] as (...args:any)=>string)(...args)
		else return commonLabels[lang][key] as string
	}

	if(typeof labels[lang][key] == "function") return (labels[lang][key] as (...args:any)=>string)(...args)
	else return labels[lang][key] as string
}

function changeTab(event:MouseEvent){
	const button = (event.target as HTMLElement).closest("button")
	const buttons = button.parentElement.querySelectorAll("button");
	const tabs = button.closest("div.tabs").querySelectorAll("div.tab")

	buttons.forEach(cur_btn=>{
		if(cur_btn == button) cur_btn.classList.add("selected")
		else cur_btn.classList.remove("selected");
	})
	tabs.forEach(tab=>{
		if(tab.id == button.getAttribute("data-tab")) tab.removeAttribute("hidden")
		else tab.setAttribute("hidden", "true");
	})
	updateHistory({"panel":button.getAttribute("data-tab")}, {replaceHist:true})
}

interface JPKBucket{
	key:string,
	doc_count:number,
	last: {
		"hits": {
			total: { value: number, relation: string },
			hits: JHitSource<JDownloadProductSource>[]
		}
	}
}